import { createApi } from '@reduxjs/toolkit/query/react';

import { AllDataResponseDto, StatusDto } from '../common/dto/common.dto';
import { DashboardCreateDto, DashboardViewDto, UpdateWidgetPositionDto, WidgetConfigDto } from '../common/dto/dashboard.dto';
import customFetchBase from './base.service';

const API_URI = import.meta.env.VITE_CHART_SERVICE;
const TAG_TYPE = 'Dashboard';

export const dashboardApi = createApi({
  reducerPath: 'dashboardApi',
  baseQuery: customFetchBase(`${API_URI}/api/dashboard`),
  tagTypes: [TAG_TYPE],
  endpoints: (builder) => ({
    saveDashboard: builder.mutation<DashboardViewDto, DashboardCreateDto>({
      query(body) {
        return {
          url: ``,
          method: 'POST',
          body,
        };
      },
      // invalidatesTags: [TAG_TYPE],
    }),
    getDashboard: builder.query<AllDataResponseDto<DashboardViewDto>, void>({
      query: () => {
        return {
          url: ``,
          method: 'GET',
        };
      },
      // providesTags: [TAG_TYPE],
    }),
    deleteDashboard: builder.mutation<StatusDto, string>({
      query(dashboardId: string) {
        return {
          url: `${dashboardId}`,
          method: 'DELETE',
        };
      },
      // invalidatesTags: [TAG_TYPE],
    }),
    getWidgets: builder.query<AllDataResponseDto<WidgetConfigDto>, string>({
      query: (dashboardId: string) => {
        return `${dashboardId}/widget`;
      },
    }),
    saveWidget: builder.mutation<WidgetConfigDto, { dashboardId: string; body: WidgetConfigDto }>({
      query({ dashboardId, body }) {
        return {
          url: `${dashboardId}/widget`,
          method: 'POST',
          body,
        };
      },
      // invalidatesTags: [TAG_TYPE],
    }),
    updateLayoutPositions: builder.mutation<StatusDto, { dashboardId: string; body: UpdateWidgetPositionDto }>({
      query({ dashboardId, body }) {
        return {
          url: `${dashboardId}/widget/update-positions`,
          method: 'PUT',
          body,
        };
      },
      // invalidatesTags: [TAG_TYPE],
    }),
    deleteWidget: builder.mutation<StatusDto, { dashboardId: string; widgetId: string }>({
      query({ dashboardId, widgetId }) {
        return {
          url: `${dashboardId}/widget/${widgetId}`,
          method: 'DELETE',
        };
      },
      // invalidatesTags: [TAG_TYPE],
    }),
  }),
});

// auto-generated based on the defined endpoints
export const {
  useLazyGetDashboardQuery,
  useSaveDashboardMutation,
  useDeleteDashboardMutation,
  useLazyGetWidgetsQuery,
  useSaveWidgetMutation,
  useUpdateLayoutPositionsMutation,
  useDeleteWidgetMutation,
} = dashboardApi;
